'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _message = require('services/message.service');

var _message2 = _interopRequireDefault(_message);

var _bulkUsageData = require('../common/bulk-usage-data/bulk-usage-data.module');

var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);

var _dashboard = require('./dashboard.component');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _message3 = require('./message/message.module');

var _message4 = _interopRequireDefault(_message3);

var _messageEdit = require('./message-edit/message-edit.module');

var _messageEdit2 = _interopRequireDefault(_messageEdit);

require('./dashboard.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.dashboard', [_angularUiRouter2.default, _bulkUsageData2.default, _message4.default, _messageEdit2.default]).component('dashboard', _dashboard2.default).service('MessageService', _message2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('dashboard', {
    parent: 'app',
    url: '/dashboard',
    component: 'dashboard',
    data: {
      permissions: {
        except: ['' + _roles.REGULATOR],
        redirectTo: 'adverseEvents'
      }
    },
    resolve: {
      adminMessage: function adminMessage(MessageService) {
        return MessageService.getAdminMessage().then(function (r) {
          return r.data;
        });
      },
      alerts: function alerts(AlertService) {
        return AlertService.getAlerts().then(function (r) {
          return r.data;
        });
      },
      companyMessage: function companyMessage($log, MessageService) {
        return MessageService.getCompanyMessage().then(function (r) {
          return r.data;
        }).catch(function (error) {
          return $log.error(error);
        });
      },
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/dashboard/dashboard.module.js